class BestsellerBadge extends HTMLElement {
  connectedCallback() {
    const rank = this.getAttribute('rank') || '#1';
    const title = this.getAttribute('title') || `BESTSELLER OF ${new Date().getFullYear()}`;
    const subtitle = this.getAttribute('subtitle') || '';
    const accent = this.getAttribute('accent') || '#e7d9c4';
    const border = this.getAttribute('border') || '1px solid rgba(0,0,0,.5)';
    const radius = this.getAttribute('radius') || '8px';
    const size = (this.getAttribute('size') || 'sm').toLowerCase();

    const root = this.attachShadow({ mode: 'open' });
    root.innerHTML = `
      <style>
        :host { display:inline-block; line-height:1; }
        .badge {
          display:inline-flex; align-items:stretch; gap:0;
          border:${border}; border-radius:${radius}; overflow:hidden;
          background:#fff;
          font-family: var(--font-body, inherit);
        }
        .left {
          background:${accent}; color:#fff; padding:6px 10px;
          display:flex; align-items:center; justify-content:center;
          font-weight:800; letter-spacing:.5px;
        }
        .right { padding:6px 12px 6px 10px; display:flex; flex-direction:column; justify-content:center; }
        .title { font-weight:800; text-transform:uppercase; letter-spacing:.02em; }
        .subtitle { margin-top:2px; opacity:.85; font-style:italic; }

        .badge[data-size="sm"] .left{ font-size:12px; }
        .badge[data-size="sm"] .title{ font-size:12px; }
        .badge[data-size="sm"] .subtitle{ font-size:10px; }

        .badge[data-size="md"] .left{ font-size:14px; }
        .badge[data-size="md"] .title{ font-size:14px; }
        .badge[data-size="md"] .subtitle{ font-size:12px; }

        @media (max-width:480px){
          .badge[data-size="md"] .title{ font-size:13px; }
          .badge[data-size="md"] .subtitle{ font-size:11px; }
        }
      </style>
      <div class="badge" data-size="${size}">
        <div class="left"><span class="rank">${rank}</span></div>
        <div class="right">
          <div class="title">${title}</div>
          ${subtitle ? `<div class="subtitle">${subtitle}</div>` : ``}
        </div>
      </div>
    `;
  }
}
customElements.define('bestseller-badge', BestsellerBadge);
